import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Initialize Lenis smooth-scroll globally. Idempotent.
 */
export default function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      smoothWheel: true,
      lerp: 0.08,
    });
    // Expose for e2e test tools / programmatic anchor scrolling
    if (typeof window !== "undefined") window.__lenis = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}
